import { Link } from "react-router-dom";
import { useSeo } from "@/hooks/useSeo";

export default function NotFound() {
  useSeo({
    title: "页面不存在 - 看片影视大全",
    description: "抱歉，你访问的页面不存在或已被移除，返回首页继续浏览影视内容。",
  });

  return (
    <div className="max-w-[900px] mx-auto px-4 md:px-8 py-20 md:py-28 flex flex-col items-center text-center">
      <p className="text-7xl md:text-9xl font-black text-background-300 select-none">404</p>
      <h1 className="mt-4 text-xl md:text-2xl font-bold text-foreground-950">页面走丢了</h1>
      <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-md">
        你访问的页面不存在或已被移除，不妨返回首页，或去看看最新的影视内容。
      </p>
      <div className="mt-7 flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
        <Link
          to="/"
          className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 dark:text-foreground-950 text-sm font-semibold whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors"
        >
          <i className="ri-home-4-line"></i>
          返回首页
        </Link>
        <Link
          to="/category/movie"
          className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-background-100 border border-background-200 text-sm font-semibold text-foreground-700 whitespace-nowrap cursor-pointer hover:border-primary-300 hover:text-primary-600 transition-colors"
        >
          浏览电影频道
        </Link>
      </div>
    </div>
  );
}